export const GroupsUriTemplates = {
    GROUPS_BASE: '/groups',
    MEMBERS: '/members',
    GROUPS_STATUSES: '/groups-statuses',
};
